import React from 'react';
import { Paper, Typography, Grid, Box, CircularProgress, Button } from '@mui/material';
import {
  Inventory2 as Inventory2Icon,
  CheckCircleOutline as CheckCircleOutlineIcon,
  WarningAmber as WarningAmberIcon,
  RemoveShoppingCart as RemoveShoppingCartIcon,
} from '@mui/icons-material';
import {
  DASHBOARD_COLORS,
  dashboardRowCardSx,
  sectionTitleSx,
  dashboardLinkButtonSx,
  dashboardMetricBoxSx,
} from './dashboardStyles';
import InsightAiAssistantButton from './ai/InsightAiAssistantButton';

const HEALTH_ITEMS = [
  { key: 'totalProducts', label: 'Total Products', icon: Inventory2Icon, color: '#2563eb', bg: '#eff6ff' },
  { key: 'inStock', label: 'In Stock', icon: CheckCircleOutlineIcon, color: DASHBOARD_COLORS.sales, bg: '#ecfdf5' },
  { key: 'lowStock', label: 'Low Stock', icon: WarningAmberIcon, color: DASHBOARD_COLORS.warning, bg: '#fffbeb' },
  { key: 'outOfStock', label: 'Out of Stock', icon: RemoveShoppingCartIcon, color: DASHBOARD_COLORS.danger, bg: '#fef2f2' },
];

const HealthStat = ({ label, value, icon: Icon, color, bg }) => (
  <Box sx={dashboardMetricBoxSx}>
    <Box
      sx={{
        width: 40,
        height: 40,
        borderRadius: 1.5,
        bgcolor: bg,
        color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Icon sx={{ fontSize: 22 }} />
    </Box>
    <Box minWidth={0}>
      <Typography
        variant="caption"
        sx={{ color: DASHBOARD_COLORS.textMuted, fontWeight: 500, display: 'block', mb: 0.25, lineHeight: 1.3 }}
      >
        {label}
      </Typography>
      <Typography sx={{ fontWeight: 700, fontSize: '1.25rem', color: DASHBOARD_COLORS.text, lineHeight: 1.2 }}>
        {value}
      </Typography>
    </Box>
  </Box>
);

const InventoryHealthGrid = ({ stats, loading, onViewAll, showAiAssistant, onAiAssistantClick }) => (
  <Paper elevation={0} sx={dashboardRowCardSx}>
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} flexWrap="wrap" gap={1}>
      <Typography sx={sectionTitleSx}>Inventory Health</Typography>
      <Box display="flex" alignItems="center" gap={1}>
        {showAiAssistant && onAiAssistantClick && (
          <InsightAiAssistantButton onClick={onAiAssistantClick} />
        )}
        {onViewAll && (
          <Button size="small" onClick={onViewAll} sx={dashboardLinkButtonSx}>
            View Full Inventory
          </Button>
        )}
      </Box>
    </Box>

    {loading ? (
      <Box flex={1} display="flex" alignItems="center" justifyContent="center" minHeight={180}>
        <CircularProgress size={28} />
      </Box>
    ) : (
      <Grid container spacing={1.5} sx={{ flex: 1 }}>
        {HEALTH_ITEMS.map((item) => (
          <Grid item xs={6} key={item.key}>
            <HealthStat
              label={item.label}
              value={stats[item.key] ?? 0}
              icon={item.icon}
              color={item.color}
              bg={item.bg}
            />
          </Grid>
        ))}
      </Grid>
    )}
  </Paper>
);

export default InventoryHealthGrid;
